import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useSpacerSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const addDL = useStore((state) => state.quote.addDL);
  const isSDL = addDL?.includes("SDL");

  const spacerColorChoice = useStore((state) => state.quote.spacerColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    if (checked) {
      addToQuote({ spacerColor: "" });
    } else {
      addToQuote({ spacerColor: label });

      if (findRequired("IG Spacer Color")) removeRequired("IG Spacer Color");
    }
  };

  const variant = (label: string) =>
    label === spacerColorChoice ? "filled" : "outlined";

  const checkMark = (label: string) => label === spacerColorChoice;

  return {
    isSDL,
    variant,
    checkMark,
    handleClick,
  };
}

export default useSpacerSelector;
